define('bizzabo/views/popup/AddPollView',[
    'backbone',
    'underscore',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/views/FormMixin',
    'bizzabo/views/ModelBindingMixin',
    'bizzabo/views/popup/PopupView',
    'bizzabo/bzapi',
    'bizzabo/config',
    'https://dme0ih8comzn4.cloudfront.net/js/feather.js',
    'bizzabo/models/Global',
    'hbars!bizzabo/templates/addPoll',
    'jquery-ui',
    'jquery-timepicker',
    'timezoneJS'
], function(
    Backbone,
    _,
    UTILS,
    Consts,
    FormMixin,
    ModelBindingMixin,
    PopupView,
    BZAPI,
    CONFIG,
    GlobalAviary,
    Global,
    addPollTemplate,
    jQueryUI,
    jQueryTimepicker,
    timezoneJS
    ) {

    var AddPollView = PopupView.extend({

        events : {
            'click .close' : 'cancelClicked',
            'click .doneButton' : 'doneClicked',
            'change .sessionsSelect': 'sessionSelected',
            'change input[name=who]' : 'formWhoCanVoteChanged',
            'change input[name=openTime]' : 'formOpenTimeHasChanged',
            'change input[name="startTime"]' : 'formStartChanged',
            'change input[name="endTime"]' : 'formEndChanged',
            'change input[type="checkbox"]': 'formVisibilityChanged',
            'change .poll-sponsor-select' : 'formSponsorChanged'
        },

        disableChosen : true,

        initialize : function() {
            this.popUpInitialize();
            this.activeEvent = Global.modelPool.getActiveEvent();
            this.modelSnapshot = this.model ? this.model.toJSON() : {};
            this.questionsSnapShot = this.model.get('questions');
            _.bindAll(this, 'dateSelected', 'formStartChanged', 'formEndChanged');

            UTILS.mixIntoMe(this, FormMixin); // mixin standard form & validation
            UTILS.mixIntoMe(this, ModelBindingMixin); // mixin model binding

            this.listenTo(this.model, 'change', this.validateModel);
            this.listenTo(this.model, 'change:start-timestamp', this.renderTimePicker);
            this.listenTo(this.model, 'change:end-timestamp', this.renderTimePicker);

            this.setStartAndEndDates();
            this.getSessions();
            this.getSponsors();
            this.initModelBinding();
            this.initValidation();
        },

        setStartAndEndDates : function() {
            this.startTimePicker = this.timeZoneToDate('start');
            this.endTimePicker = this.timeZoneToDate('end');
        },

        timeZoneToDate : function(endOrStart) {
            var timeStamp = this.activeEvent.get(endOrStart + '-timestamp');

            if (!timeStamp) {
                return this.$('input[name="' + endOrStart + 'DatePicker"]').val();
            }

            var timeZone = this.activeEvent.get('time-zone-id');
            var date = new timezoneJS.Date(timeZone);
            date.setTimezone(timeZone);
            date.setTime(timeStamp);
            var parsedDate = (date.getMonth() + 1) +'/' + date.getDate() + '/' + date.getFullYear();
            return parsedDate;
        },

        formSponsorChanged : function() {
            var sponsorId = this.$('.poll-sponsor-select').val();
            if (!sponsorId) {
                this.$('.poll-sponsor-logo').toggleClass('hide', true);
                this.model.unset('partner-id');
                return;
            }
            this.model.set('partner-id', this.$('.poll-sponsor-select').val());
            var sponsor = _.findWhere(this.sponsorsData, {sponsorId: parseInt(sponsorId, 10)});
            this.$('.poll-sponsor-img').attr('src', sponsor.sponsorImg);
            this.$('.sponsorName').html(sponsor.sponsorName);
            this.$('.poll-sponsor-logo').toggleClass('hide', false);
        },

        formVisibilityChanged : function(e) {
            var checkBox = this.$(e.target);
            var oldState = checkBox.attr('checked');
            oldState = oldState ?  true : false;
            var field = checkBox.attr('value');
            if (field == 'show-inactive') {
                this.model.set(field, oldState);
            } else {
                this.model.set(field, !oldState);
            }
            checkBox.parent().toggleClass('checkedBox', !oldState);
            checkBox.attr('checked', !oldState);
        },

        formWhoCanVoteChanged : function() {
            var value = this.$('input[name="who"]:checked').val();
            this.model.set('private', value);
        },

        formOpenTimeHasChanged: function() {
            var value = this.$('input[name="openTime"]:checked').val();
            this.$('.pollDatesWrapper').toggleClass('pollDatesWrapper-open', false);
            switch (value) {
                case 'button':
                    this.model.unsetDates();
                    this.model.set('start-method', 'manual');
                    break;
                case 'manual':
                    this.$('.pollDatesWrapper').toggleClass('pollDatesWrapper-open', true);
                    this.model.set('start-method', 'scheduled');
                    this.setTimeIfHasValue();
                    break;
                case 'session':
                    this.model.set('start-method', 'session');
                    this.setSessionStartTime();
                    break;
                default:
            }
        },

        setTimeIfHasValue : function() {
            if (this.startTimePicker) {
                this.formStartChanged();
            }

            if (this.endTimePicker) {
                this.formEndChanged();
            }
        },

        dateSelected : function(date, obj) {
            if (obj.id == 'startTimePicker') {
                this.startTimePicker = date;
                this.formStartChanged();
            } else {
                this.endTimePicker = date;
                this.formEndChanged();
            }
        },

        formStartChanged : function(e, time) {
            this.generateTimestamp('start');
        },

        formEndChanged : function(e, time) {
            this.generateTimestamp('end');
        },

        generateTimestamp : function(startOrEnd) {
            var timeZone = this.activeEvent.get('time-zone-id');
            var startTime = this.$('input[name="' + startOrEnd + 'Time"]').val();
            var amPmIndex = startTime.indexOf('pm') === -1 ? startTime.indexOf('am') : startTime.indexOf('pm');
            var amPm = startTime.slice(amPmIndex);
            var parseHours = new Date('1 Jan 2000 ' + startTime.substring(0, amPmIndex) + ' ' + amPm);
            var parseDate = (startOrEnd == 'start') ? this.startTimePicker.split('/') : this.endTimePicker.split('/');
            var tzDate = new timezoneJS.Date(parseInt(parseDate[2], 10), parseInt(parseDate[0], 10) - 1, parseInt(parseDate[1], 10), parseHours.getHours(), parseHours.getMinutes(), timeZone);
            this.model.set(startOrEnd +'-timestamp', tzDate.getTime());
        },

        setSessionStartTime : function() {
            var sessionId = this.model.get('session-ids')[0];
            var dayIndex = 0;
            var session = null;
            var agenda = Global.modelPool.getAgenda(this.activeEvent.get('id'));
            var days = agenda.get('day');
            days.each(function(day, index) {
                var sessions = day.get('session');
                if (sessions.get(sessionId)) {
                    session = sessions.get(sessionId);
                    dayIndex = index;
                }
            });

            var timeStamp = this.activeEvent.get('start-date');
            var timeZone = this.activeEvent.get('time-zone-id');
            this.model.setTimestampBySession(timeStamp, timeZone, session, dayIndex);
        },

        doneClicked : function() {
            this.model.validate();
            if (!this.model.isAllModelValid()) {
                return;
            }

            this.model.save(null, {
                error: function() {
                    Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                        msg : 'Could not save changes.',
                        errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.ERROR,
                        autoHide : true
                    });
                }
            });
            this.hide();
        },

        cancelClicked : function() {
            if (this.model.isNew()) {
                this.model.destroy();
            } else {
                this.removeValidation();
                this.revertModelToSnapshot();
                this.model.validate();
            }
            this.hide();
        },

        getSponsors : function() {
            var sponsors = Global.modelPool.getPartners(this.activeEvent.get('id'));
            this.sponsorsData = [];
            var thisView = this;
            sponsors.each(function(sponsor) {
                thisView.sponsorsData.push({
                    sponsorName: sponsor.get('company-name'),
                    sponsorId: sponsor.get('id'),
                    sponsorImg: sponsor.get('logo-url') ? sponsor.get('logo-url') : ""
                });
            });
        },

        getSessions : function() {
            var agenda = Global.modelPool.getAgenda(this.activeEvent.get('id'));
            this.agnedaDays = agenda.get('day');
        },

        sessionSelected: function(evt, params) {
            var sessionsArray = UTILS.ensureArray(this.model.get('session-ids'));

            if (params.selected) {
                sessionsArray.push(params.selected);
            } else if (params.deselected) {
                sessionsArray.pop(params.selected);
            }

            this.model.set('session-ids', sessionsArray);
            this.renderUseSessionRadio();
        },

        validateModel: function () {
            this.model.validate();
        },

        revertModelToSnapshot : function() {
            var oldKeys = _.keys(this.modelSnapshot);
            var newKeys = _.keys(this.model.attributes);
            var diff = _.difference(newKeys, oldKeys);

            this.model.set(this.modelSnapshot);
            this.model.set('questions', this.questionsSnapShot);
            for (var i = 0; i < diff.length; i++) {
                this.model.unset(diff[i]);
            }
        },

        remove : function() {

            this.model.validate();

            this.removeModelBinding();
            this.removeValidation();
            this.popupRemove();
        },

        renderTimePicker : function() {
          if (!this.model.has('start-timestamp')) {
                this.$('input[name="startTime"]').attr('disabled', 'disabled');
          } else {
              this.$('input[name="startTime"]').removeAttr('disabled');
          }
          if (!this.model.has('end-timestamp')) {
            this.$('input[name="endTime"]').attr('disabled', 'disabled');
          } else {
            this.$('input[name="endTime"]').removeAttr('disabled');
          }
        },

        renderSponsorSelect : function() {
            if (this.model.get('partner-id')) {
                this.$('.poll-sponsor-logo').toggleClass('hide', false);
                var selectedSponsor = _.findWhere(this.sponsorsData, {sponsorId: this.model.get('partner-id')});
                this.$('.poll-sponsor-select').val(selectedSponsor.sponsorId);
                this.$('.poll-sponsor-img').attr('src', selectedSponsor.sponsorImg);
                this.$('.sponsorName').html(selectedSponsor.sponsorName);
            }
        },

        renderMultiSelect : function() {
            if (this.model.get('session-ids')) {
                var sessions = UTILS.ensureArray(this.model.get('session-ids'));
                this.$('.sessionsSelect').val(sessions);
                this.$('.sessionsSelect').trigger("chosen:updated");
            }
        },

        renderToolTips : function() {
            this.$('[data-toggle="tooltip"]').tooltip();
        },

        renderUseSessionRadio : function(fromRender) {
            var sessionsArray = UTILS.ensureArray(this.model.get('session-ids'));
            if (sessionsArray.length === 1) {
                this.$('.pollSessionTimeRadio').removeAttr('disabled');
            }  else {
                this.$('.pollSessionTimeRadio').attr('disabled', 'disabled');
                if (!fromRender) {
                    this.$('.pollManualTimeRadio').click();
                }
                this.model.unset('session-time');
            }
        },

        render : function() {
            var jsonModel= _.extend(this.model.toJSON(), {
                days: this.agnedaDays.toJSON(),
                sponsorsData: this.sponsorsData,
                isNew: this.model.isNew(), //can use helper
                timeZone: this.activeEvent.get('time-zone-id')
            });
            var html = addPollTemplate(jsonModel);
            this.$el.html(html);
            this.renderTimePicker();
            this.renderSponsorSelect();
            this.renderMultiSelect();
            this.renderToolTips();
            this.renderUseSessionRadio(true);
            this.setStartAndEndDates();
            this.$el.addClass('poll-popup');

            return this;
        },

        viewRendered : function() {
            this.renderForm();
            this.$('.sessionsSelect').chosen();
            this.$('.dateField').datepicker({onSelect: this.dateSelected});
            this.$('input[name="startDatePicker"]').datepicker('option', 'minDate', new Date());
            this.$('.timeField').timepicker({
                className : 'pollTimePicker',
                maxTime : '11:59pm',
                minTime : '7:00am',
                'step': 30
            });
        }
    });

    return AddPollView;

});
